// Single source of truth for language configuration
export const SUPPORTED_LANGUAGES = ["en", "zh", "ru", "es", "hi", "ja", "de", "it", "fr", "sv", "fi"] as const;

export type Language = typeof SUPPORTED_LANGUAGES[number];

export const LOCALE_MAP: Record<Language, string> = {
  en: "en_US",
  zh: "zh_CN",
  ru: "ru_RU",
  es: "es_ES",
  hi: "hi_IN",
  ja: "ja_JP",
  de: "de_DE",
  it: "it_IT",
  fr: "fr_FR",
  sv: "sv_SE",
  fi: "fi_FI"
};

export const LANGUAGE_NAMES: Record<Language, string> = {
  en: "English",
  zh: "中文",
  ru: "Русский",
  es: "Español",
  hi: "हिन्दी",
  ja: "日本語",
  de: "Deutsch",
  it: "Italiano",
  fr: "Français",
  sv: "Svenska",
  fi: "Suomi"
};

export const COUNTRY_CODES: Record<Language, string> = {
  en: "gb",
  zh: "cn",
  ru: "ru",
  es: "es",
  hi: "in",
  ja: "jp",
  de: "de",
  it: "it",
  fr: "fr",
  sv: "se",
  fi: "fi"
};

export const STORAGE_KEY = "duelbonus_language";

// Detect browser language
export const detectBrowserLanguage = (): Language => {
  const browserLang = navigator.language.split("-")[0] as Language;
  return SUPPORTED_LANGUAGES.includes(browserLang) ? browserLang : "en";
};

// Get initial language from storage or browser
export const getInitialLanguage = (): Language => {
  const stored = localStorage.getItem(STORAGE_KEY) as Language | null;
  if (stored && SUPPORTED_LANGUAGES.includes(stored)) {
    return stored;
  }
  return detectBrowserLanguage();
};
